module.exports = function() {
  return new Worker(__webpack_public_path__ + "a08d28db05070a899eb5.worker.js");
};